import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { configEnv } from './util/config-file';
import socketStore from 'store/socket';
import clientStore from 'store/client-store';
import { AxiosResponse } from 'axios';
import { IApp } from 'interfaces/base';
const packageConfig = require('../package.json');

// mode: staging/production
if (
  process.env.NODE_ENV === 'production' &&
  configEnv.get().sentryEnable &&
  location.hostname !== 'localhost'
) {
  Sentry.init({
    release: packageConfig.version,
    dsn: 'https://fc96a58203e5445c9f557d90a09ff811@vkyc-sentry.advance.ai/3',
    environment: `${configEnv.get().versionName}-${process.env.MODE}`,
  });
}

// Sentry.init({
//   release: packageConfig.version,
//   dsn: 'https://fc96a58203e5445c9f557d90a09ff811@vkyc-sentry.advance.ai/3',
//   environment: `${configEnv.get().versionName}-${process.env.MODE}`,
// });
// sendTestEvent();

function setExtraUserInfo(scope: Sentry.Scope) {
  scope.setExtra('videoInfo', socketStore.getSocketData());
  scope.setExtra('clientInfo', clientStore.getSession());
}

export function sentryExceptionHandler(
  this: React.Component<{}, IApp>,
  error: Error,
  errorInfo: React.ErrorInfo,
) {
  Sentry.withScope((scope) => {
    scope.setExtra('Error Info', errorInfo);
    setExtraUserInfo(scope);
    const eventId = Sentry.captureException(error);
    this.setState({ eventId });
  });
}

export function sendAPISentry(response: AxiosResponse) {
  const { status, data, request, config } = response;
  Sentry.withScope((scope) => {
    scope.setTag('error.type', 'API_ERROR');
    scope.setTag('host', location.host);
    scope.setExtra('request', request);
    scope.setExtra('config', config);
    scope.setExtra('response', data);
    setExtraUserInfo(scope);
    Sentry.captureException(new Error(`${status}: ${data?.message}`));
  });
}

export function sendOTSentry(detail: any) {
  Sentry.withScope((scope) => {
    scope.setTag('error.type', 'OT_ERROR');
    scope.setTag('host', location.host);
    scope.setExtra('OTErrLog', detail);
    setExtraUserInfo(scope);
    Sentry.captureException(new Error(`${status}: ${detail?.name}`));
  });
}

export function sendTestEvent() {
  Sentry.captureEvent({
    extra: { test: 'hello 哈哈哈', env: process.env.MODE },
    message: 'test-' + new Date(),
    level: Sentry.Severity.Error,
  });
}

export function sendTestSentry() {
  console.log('send test Sentry!');
  Sentry.withScope((scope) => {
    scope.setTag('type', 'test');
    scope.setTag('host', location.host);
    setExtraUserInfo(scope);
    Sentry.captureEvent({ message: 'test-' + new Date() });
  });
}
